import React from "react";
import { RouterProvider } from "react-router-dom";
import { PricingProvider } from "../context/pricing/PricingContext";
import { createAppRouter } from "./router";

export default function ClientApp() {
  const [router] = React.useState(createAppRouter);

  return (
    <React.StrictMode>
      <PricingProvider>
        <RouterProvider router={router} />
      </PricingProvider>
    </React.StrictMode>
  );
}
